import { render, staticRenderFns } from "./ViewItemAction.vue?vue&type=template&id=1fb47eba&"
import script from "./ViewItemAction.vue?vue&type=script&lang=js&"
export * from "./ViewItemAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports